import { Injectable } from '@angular/core';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { PrimkeService } from '../pages/primke/primke.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaPrimkeService {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  stavke: any = [];

  constructor(private service: PrimkeService, private authService: AuthService) {}

  pdfPrimka(data) {
    //console.log('DATA: ', data);

    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: data.data.pz_id,
    };
    /* kod zavrsenih ili storniranih dohvaca iz jedne tablice a kod onih u izradi iz druge zato su razliciti api-i */
    if(data.data.pz_status == 'Z' || data.data.pz_status == 'S'){
      this.service.primkaStavkePopis(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
        this.kreirajPDF(data);
      });
    }else{
      this.service.tmpprometstavkePopis(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
        this.kreirajPDF(data);
      });
    }

  }

  izracunajRekapitulaciju(stavke) {
    const porezi = {};

    if(stavke) {
      stavke.forEach(stavka => {
        const osnovica = stavka.ps_ulazvr;
        const porez = osnovica * stavka.pz_posto / 100;

        if(!porezi[stavka.pz_posto]) {
          porezi[stavka.pz_posto] = { osnovica: 0, porez: 0};
        }

        porezi[stavka.pz_posto].osnovica += osnovica;
        porezi[stavka.pz_posto].porez += porez;
      });

      return Object.keys(porezi).map(key => ({
        stopa: key,
        ukupanIznos: porezi[key].osnovica + porezi[key].porez,
        osnovica: porezi[key].osnovica.toFixed(2),
        iznosPoreza: porezi[key].porez.toFixed(2),
      }));
    }
  }

  kreirajPDF(data){

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];

    ct.push({
      columns: [
        {
          table: {
            widths: [200],
            heights: [85],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: '',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: '',
                          style: 'subtitle',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
          layout: 'noBorders',
        },

        {
          table: {
            widths: [250],
            heights: [85],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'PEKAR d.o.o.',
                          style: 'title',
                        },
                      ],
                      [
                        {
                          text: 'Obrtnička 5',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Vinkovci',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030084282, OIB: 67289965400. Temeljni kapital 5.384.400,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Raiffeisen Bank 2484008-1106129914   IBAN: HR4024840081106129914 Ž.r. Otp bank 2407000-1100629330 IBAN: HR4024070001100629330 SWIFT: OTPVHR2X',
                          style: 'details',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },
      ],
    });

    ct.push({
      text: '\n',
    });

    let naziv = '';
    if (data.data.pa_naziv) {
      naziv = data.data.pa_naziv;
    } else if (data.data.pp_naziv){
      naziv = data.data.pp_naziv;
    }

    let adresa = '';
    if (data.data.pa_adresa) {
      adresa = data.data.pa_adresa;
    } else if (data.data.pp_adresa){
      adresa = data.data.pp_adresa;
    }

    let posta = '';
    if (data.data.pa_posta) {
      posta = data.data.pa_posta;
    } else if (data.data.pp_posta){
      posta = data.data.pp_posta;
    }

    let mjesto = '';
    if (data.data.pa_mjesto) {
      mjesto = data.data.pa_mjesto;
    } else if (data.data.pp_mjesto){
      mjesto = data.data.pp_mjesto;
    }

    ct.push({
      columns: [
        {
          text: ` 
            Dobavljač: 
            ${ naziv }
            ${ adresa }
            ${ posta }` + ' ' + `${ mjesto }`,
          style: 'subtitle',
          bold: true,
        },
        {
          text:
            '\n' +
            `Datum primke: ${moment(data.data.pz_datum).format('DD.MM.YYYY')}.
            Datum kreiranja: ${moment(data.data.pz_danisat).format('DD.MM.YYYY. HH:mm:ss')}.
            Broj dokumenta: ${data.data.pz_dokumpar || ''}
            ${data.data.po_sifrainaziv || ''}`,
          style: 'subtitle',
        },
      ],
    });

    ct.push({
      text: '\n' + '\n',
    });

    //SREDINA PRIMKE I BROJ PRIMKE
    ct.push({
      text:
        'Primka: ' +
        data.data.po_sifra +
        '-' +
        data.data.pz_broj +
        '/' +
        moment(data.data.pz_datum).format('YYYY'),
      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 0, 0, 0],
    });

    //GLAVNA TABLICA I PODACI
    let brojac = 1;
    let ukupnoKolicina = 0;
    let ukupnoCijena = 0;
    let ukupnoVrijednost = 0;
    let ukupnoIznos = 0;

    //let arr = this.stavke;

    ct.push(hLine);
    ct.push({
      table: {
        widths: [10, 27, 80, 20, 40, 45, 30, 35, 27, 27, 45],
        body: [
          [
            'Rb',
            'Šifra' + '\n' + 'LOT',            
            'Naziv artikla',
            'Jed. mjere',
            'Rok trajanja',
            'Količina',
            'Cijena',
            'Vrijednost',
            'Rabat %',
            'Porez %',
            'Iznos'
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    ct.push(hLine);
    for (let stavka of this.stavke) {
      let stavkaSifra = '';
      let stavkaNaziv = '';
      let stavkaLot = '';
      let stavkaJedMjere = '';
      let stavkaRokTrajanja = '';
      let stavkaKolicina = 0;
      let stavkaCijena = 0;
      let stavkaVrijednost = 0;
      let stavkaRabat = '0';
      let stavkaPorez = '0';
      let stavkaIznos = 0;
      
      //console.log('STAVKA: ', stavka);

      stavkaSifra = stavka.ar_sifra + '\n' + stavka.ar_lot;
      stavkaNaziv = stavka.ar_naziv;
      stavkaLot = stavka.ar_lot;
      stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
      stavkaRokTrajanja = stavka.ps_vazido
        ? moment(stavka.ps_vazido).format('DD.MM.YYYY.')
        : '';
      stavkaKolicina = stavka.ps_ulaz;
      stavkaCijena = stavka.ps_ulazc;
      stavkaVrijednost = stavka.ps_ulazvr;
      stavkaRabat = stavka.ps_postorabata + ' %';
      stavkaPorez = stavka.pz_posto + ' %';
      stavkaIznos = stavka.ukupnacijena;

      ukupnoKolicina += stavka.ps_ulaz;
      ukupnoCijena += stavka.ps_ulazc;
      ukupnoVrijednost += (stavka.ps_ulazvr);
      ukupnoIznos += (stavka.ukupnacijena);
      

      ct.push({
        table: {
          widths: [10, 27, 80, 20, 40, 45, 30, 35, 27, 27, 40],
          body: [
            [
              { text: brojac++ },
              { text: stavkaSifra },
              { text: stavkaNaziv },
              { text: stavkaJedMjere },
              { text: stavkaRokTrajanja },
              { text: this.formatiraj(stavkaKolicina, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaCijena, 5), alignment: 'right' },
              { text: this.konvertiraj(stavkaVrijednost), alignment: 'right' },
              { text: stavkaRabat, alignment: 'right' },
              { text: stavkaPorez, alignment: 'right' },
              { text: this.konvertiraj(stavkaIznos), alignment: 'right' }
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }
 
    //UKUPNO
    ct.push(hLine);
    ct.push({
      table: {
        widths: [250, 45, 40, 40, 40, 40, 50],
        body: [
          [
            {
              text: 'UKUPNO',
              style: 'tableFooter',
              margin: [200, 0, 0, 0],
            },
            { text: this.formatiraj(ukupnoKolicina, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoCijena, 5), alignment: 'right', style: 'tableFooter' },
            { text: this.konvertiraj(ukupnoVrijednost), alignment: 'right', style: 'tableFooter' },
            { text: '', alignment: 'right', style: 'tableFooter' },
            { text: '', alignment: 'right', style: 'tableFooter' },
            { text: this.konvertiraj(ukupnoIznos) + ' EUR', alignment: 'right', style: 'tableFooter' },
          ],
        ],
      },
      layout: 'noBorders',
    });

    const rekapitulacijaPoreza = this.izracunajRekapitulaciju(this.stavke)

    ct.push({
      text: '\n\n\n'
    })

    ct.push({
      table: {
        headerRows: 1,
        widths: ['*',100, 'auto', 'auto', 'auto'],
        body: [
          [
            {text: '', border: [false, false, false, false]},
            {text: 'Rekapitulacija poreza', border: [false, false, false, true]},
            {text: '% poreza', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}, 
            {text: 'Osnovica', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}, 
            {text: 'Iznos poreza', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}
          ],
          ...rekapitulacijaPoreza.map(stavka => [{text: '', border: [false, false, false, false]},{text: '', border: [false, false, false, false]}, {text: stavka.stopa + '%', alignment: 'right', border: [false, false, false, false]}, {text: this.konvertiraj(stavka.osnovica), alignment: 'right', border: [false, false, false, false]}, {text: this.konvertiraj(stavka.iznosPoreza), alignment: 'right', border: [false, false, false, false]},]),          
          [
            { text: '', border: [false, false, false, false]},
            { text: 'Ukupno', bold: true, border: [false, true, false, false]},
            { text: '', border: [false, true, false, false]},
            { text: '', bold: true, alignment: 'right', border: [false, true, false, false]},
            { text: this.konvertiraj(rekapitulacijaPoreza.reduce((sum, item) => sum + parseFloat(item.ukupanIznos), 0).toFixed(2)) + ' EUR', bold: true, alignment: 'right', border: [false, true, false, false]}
          ]
        ]
      }, 
    });

    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              [
                {
                  text: 'Napomena: ' , decoration: 'underline',
                  bold: true,
                },
              ],
              [
                {
                  text: data.data.pz_napomena
                },
              ],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    var dd = {
      info: {
        title: 'Primka: ' + data.data.pz_id,
      },
      content: ct,
      pageMargins: 20,
      defaultStyle: {
        fontSize: 7.5,
      },
      styles: {
        title: {
          fontSize: 12,
          bold: true,
        },
        subtitle: {
          fontSize: 10,
        },
        details: {
          fontSize: 6,
        },
        tableTitle: {
          fontSize: 8,
          bold: true,
        },
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        tableFooter: {
          bold: true,
        },
      },
    };

    pdfMake.createPdf(dd).open();
  }

  konvertiraj(a: any) {
    return this.authService.konvertirajCijenu().konvertiraj(a);
  }

  konvertiraj_3decimal(a: any) {
    return this.authService.konvertiraj().konvertiraj_3decimal(a);
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }

}